<section class="vechicle-range-sec pb-5 pt-5 position-relative">
  <img [src]='environment1 + "assets/images/Square T.svg"' class="t-image" alt="T">
                <div class="horizontal-line"></div>
                <div class="vertical-line"></div>
                <div class="bottom-horizontal-line"></div>
                <div class="bottom-vertical-line"></div>
                <div class="unique-border-box"></div>
                <div class="right-vertical-line"></div>
  <div class="container mt-5 container-explore">
    <div class="content-heading mb-4 d-block d-md-flex align-items-center">


      <h1 class="page-sub-title cv-text-dark">Explore Vehicle Range</h1>
      <nav class="ms-auto bg-light-gray mt-4 mt-md-0">
        <div class="nav nav-pills nav-justified" id="pills-tab" role="tablist">
          <button class="nav-link active" id="pills-home-tab" data-bs-toggle="tab" data-bs-target="#pills-home"
            type="button" role="tab" aria-controls="nav-home" aria-selected="true"
            (click)="onTabClickapi('Trucks')">Trucks</button>
          <button class="nav-link" id="pills-profile-tab" data-bs-toggle="tab" data-bs-target="#pills-profile"
            type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
            (click)="onTabClickapi('Buses')">Buses</button>
          <button class="nav-link" id="pills-contact-tab" data-bs-toggle="tab" data-bs-target="#pills-contact"
            type="button" role="tab" aria-controls="pills-contact" aria-selected="false"
            (click)="onTabClickapi('Vans')">Vans</button>
            <button class="nav-link" id="pills-contact-tab" data-bs-toggle="tab" data-bs-target="#pills-contact"
            type="button" role="tab" aria-controls="pills-contact" aria-selected="false"
            (click)="onTabClickapi('SCV & Pickups')">SCV & Pickups</button>
        </div>
      </nav>
    </div>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <div class="row g-4">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xx-3 flex-item"
            *ngFor="let item of newexploreVehicleRangeRESPList">
            <div class="item d-block d-lg-flex align-items-center" (click)="explorePage(item.l2_actual_name)">
              <div class="icon me-3">
                <img src="{{item.l1_image_path_l ? item?.l1_image_path_l:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" class="img-fluid" alt="{{item.img?item.img:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" loading="lazy">
              </div>
              <div class="item-content d-flex align-items-center w-100">
                <div class="ltr-content pe-4 me-auto">
                  <h6 class="fw-bold">{{item.l2_actual_name}}</h6>

                  <p class="mb-0"> {{item.display_description1}} </p>
                  <p class="mb-0" *ngIf="item.display_description2 != ''"> {{item.display_description2}}
                  </p>
                </div>
                <div class="view-more d-none d-lg-block">
                  <img [src]="environment1 + 'images/new-images/rightArrowdarkBlue.svg'" alt="right ArrowdarkBlue" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <div class="row g-4">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xx-3 flex-item"
            *ngFor="let item of newexploreVehicleRangeRESPList">
            <div class="item d-block d-lg-flex align-items-center" (click)="explorePage(item.l2_actual_name)">
              <div class="icon me-3">
                <!-- <img src="{{item.img?item.img:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" class="img-fluid" alt="{{item.img?item.img:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" loading="lazy"> -->
                <img src="{{item?.l1_image_path_l ? item?.l1_image_path_l:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" class="img-fluid" alt="{{item?.l1_image_path_l ? item?.l1_image_path_l:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" class="img-fluid" alt="truck-icon" loading="lazy">

              </div>
              <div class="item-content d-flex align-items-center w-100">
                <div class="ltr-content pe-4 me-auto">
                  <h6 class="fw-bold">{{item.l2_actual_name}}</h6>

                </div>
                <div class="view-more d-none d-lg-block">
                  <img [src]="environment1 + 'images/new-images/rightArrowdarkBlue.svg'" alt="right ArrowdarkBlue" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
        <div class="row g-4">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xx-3 flex-item"
            *ngFor="let item of newexploreVehicleRangeRESPList">
            <div class="item d-block d-lg-flex align-items-center" (click)="explorePage(item.l2_actual_name)">
              <div class="icon me-3">
                <img src="{{item?.l1_image_path_l ? item?.l1_image_path_l:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" class="img-fluid" alt="{{item?.l1_image_path_l ? item?.l1_image_path_l:'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/truck-icon.png'}}" class="img-fluid" alt="truck-icon" loading="lazy">
              </div>
              <div class="item-content d-flex align-items-center w-100">
                <div class="ltr-content pe-4 me-auto">
                  <h6 class="fw-bold">{{item.l2_actual_name}}</h6>

                </div>
                <div class="view-more d-none d-lg-block">
                  <img [src]="environment1 + 'images/new-images/rightArrowdarkBlue.svg'" alt="right ArrowdarkBlue" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

